import { LocaleTypes } from "types";

export const HEADER_HEIGHT = 72;
export const FOOTER_HEIGHT = 56;

export const ROWS_IN_TABLE = [25, 50, 100];

export const BASE_PATH = "developer";

export const locales: LocaleTypes[] = ["en", "pt", "ar"];
export const LOCALES_MAP = {
  en: { flag: "GB", text: "English", muiLocale: "enUS" },
  pt: { flag: "PT", text: "Portuguese", muiLocale: "ptPT" },
  ar: { flag: "SA", text: "Arabic", muiLocale: "arEG" },
};

export const publicFolderPath = process.env.PUBLIC_URL;

export const defaultProductData = [
  {
    title: "BRAZIL AISP",
    scopes: "accounts",
  },
  {
    title: "BRAZIL PISP",
    scopes: "payments",
  },
  {
    title: "BRAZIL CBPII",
    scopes: "fundsconfirmations",
  },
];
